<template>
  <td class="soprts_in_acc_2 "
      :style="[width === 2 ? {'width': '50%'} : {'width': '33%'}]"
      :class="{'sel': checkCart(bets)}"
      @click="addCart(bets, folder, game)"
  >
    <div class="sports_v_l_1">
      {{ teamName }}
    </div>
    <div class="sports_v_r_1">
      <i v-if="priceStatus === 'up'" class="ico-up blink"></i>
      <i v-if="priceStatus === 'down'" class="ico-down blink"></i>
      <span class="font_002 ">
        {{ Number(bets.price).toFixed(2) }}
      </span>
      <i v-if="priceStatus" class="sel_old ">({{ startPrice }})</i>
    </div>
  </td>
</template>

<script>
export default {
  name: "Price",
  props: ['bets', 'folder', 'addCart', 'checkCart', 'game', 'team', 'width'],
  data: function(){
    return {
      startPrice: null,
      priceStatus: null,
    }
  },
  mounted() {
    console.log(this.width);
  },
  computed: {
    type: function(){
      let type = 'home';
      if (this.bets.name === 'W1' || this.bets.name === 'Home' || this.bets.name === 'Over' || this.bets.name === '1X' || this.bets.name === 'Odd' || this.bets.name === 'Yes') return 'home';
      if (this.bets.name === 'X' || this.bets.name === '12') return 'draw';
      if (this.bets.name === 'W2' || this.bets.name === 'Away' || this.bets.name === 'Under' || this.bets.name === 'X2' || this.bets.name === 'Odd' || this.bets.name === 'No') return 'away';
      return type
    },
    price: function(){
      return Number(this.bets.price).toFixed(2)
    },
    teamName: function(){
      let name = this.team.nameKr || this.team.nameEn;
      if (this.folder.market.nameEn.indexOf('Player Points') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Rebounds') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Assists') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Points and Assists') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Points and Rebounds') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Assists and Rebounds') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Points, Assists and Rebounds') >= 0){
        const playerName = this.folder.name.split(')')[0];
        if (this.bets.name === 'Over') return `${playerName}) 오버 (${this.bets.line})`;
        if (this.bets.name === 'Under') return `${playerName}) 언더 (${this.bets.line})`;
      }
      if ([13750, 13751,13752,13753,13754,13755,13756,13757,13758,13759,13760,13761,13761,13762,14591,14594].includes(this.folder.marketId)){
        const playerName = this.folder.name.split('(')[0];
        if (this.bets.name === 'Over') return `${playerName}) 오버 (${this.bets.line})`;
        if (this.bets.name === 'Under') return `${playerName}) 언더 (${this.bets.line})`;
      }
      if (
          this.folder.market.nameEn.indexOf('Player Total Kills') >= 0 ||
          this.folder.market.nameEn.indexOf('Player Total Assists') >= 0
      ){
        const playerName = this.folder.name.split(' ')[0];
        if (this.bets.name === 'Over') return `${playerName} 오버 (${this.bets.line})`;
        if (this.bets.name === 'Under') return `${playerName} 언더 (${this.bets.line})`;
      }
      if (this.folder.market.nameEn.includes('Players Specials and Match Winner')){
        return this.bets.displayName;
      }
      if (this.bets.name in ['Home', 'Away']) name = `${this.team.nameKr || this.team.nameEn} (${this.bets.line})`;
      if (this.bets.name === 'Over') return `오버 ${this.bets.line}` ;
      if (this.bets.name === 'Under') return `언더 ${this.bets.line}`;
      if (this.bets.name === 'X') name = '무';
      if (this.bets.name === '1X') name = '1팀승 또는 무승부';
      if (this.bets.name === '12') name = '1팀승 또는 2팀승';
      if (this.bets.name === 'X2') name = '무승부 또는 2팀승';
      if (this.bets.name === 'Odd') name = '홀';
      if (this.bets.name === 'Even') name = '짝';
      if (this.bets.name === 'Yes') name = '예';
      if (this.bets.name === 'No') name = '아니오';
      if (this.bets.name === 'NoGoal') name = '노골';
      if (this.bets.name === 'W1andOver') {
        name = this.bets.name.replace('W1andOver', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 오버`)
      }
      if (this.bets.name === 'W2andOver'){
        name = this.bets.name.replace('W2andOver', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 오버`)
      }

      if (this.bets.name === 'W1andUnder') {
        name = this.bets.name.replace('W1andUnder', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 언더`)
      }
      if (this.bets.name === 'W2andUnder') {
        name = this.bets.name.replace('W2andUnder', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 언더`)
      }
      if (this.folder.market.isHandicap === 'y') name += ` (${this.bets.line})`
      return name;
    },
  },
  watch: {
    price: function(newVal, val){
      if (Number(newVal) - Number(val) < 0) this.priceStatus = 'up';
      if (Number(newVal) - Number(val) > 0) this.priceStatus = 'down';
      if (Number(newVal) !== Number(val)) this.startPrice = val;
    },
    priceStatus: function(){
      setTimeout(() => {
        this.priceStatus = null
        this.startPrice = null;
      } ,5000)
    },
  },
}
</script>

<style scoped>
.blink {
  animation: top-arrow-down 1s 10!important;
}
</style>
